import React, { useState, useEffect } from 'react';
import Loader from '../general/Loader';
import { styled } from "styled-components";
import Row from '../general/Row';

let onlineDealerUrl : string;
const dealerLocatorReact = document.getElementById('dealer-locator-react');

if(dealerLocatorReact !== null) {
  onlineDealerUrl = dealerLocatorReact.getAttribute('data-online-dealer-url') as string;
}

interface Dealer {
  name: string;
}

interface Website {
  actualUrl: string;
  displayUrl: string;
}

interface Result {
  dealer: Dealer;
  website: Website;
}

const StyledDealer = styled.div`
  @media (min-width: 1025px) {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }

  @media (max-width: 768px) {
    width: 100%;
  }

  @media (min-width: 768px) {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
  }

  position: relative;
  padding-right: 15px;
  padding-left: 15px;
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #fff;

  .tile {
    padding: 16px 8px;
    border-bottom: 1px solid #ccc;
  }

  .name {
    font-size: 18px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    color: #000;
    letter-spacing: .3px;
    text-transform: uppercase;
  }

  a {
    font-size: 14px;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    text-transform: lowercase;
    text-decoration: none;
    color: #d52b1e;
  }
`;

const OnlineDealerHeader = styled.h2`
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid #ccc;
    font-size: 36px;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.19;
    color: #000;
`;

interface Props {
  site: string | null;
  country: string;
  brandKey: string;
}

const OnlineDealers: React.FC<Props> = ({ site, country, brandKey }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [results, setResults] = useState<Result[]>([]);
  const [data, setData] = useState<string>('');
  const [error, setError] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>('');

  const getOnlineDealers = () => {
    setLoading(true);

    let data = {
      brand: brandKey,
      country: country
    };

    let apiUrl = onlineDealerUrl;

    setData(JSON.stringify(data));
   // console.log('post data', data);

    const postData = {
      method: "POST",
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(data)
    };

    fetch(apiUrl, postData)
    .then(res => res.json())
    .then(data => {
      console.log('response data', data);
      if(data.data && data.data.onlineDealers && data.data.onlineDealers.length) {
        setResults(data.data.onlineDealers);
        setError(false);
        setErrorMsg('');
        setLoading(false);
        return;
      }
      else {
        setError(true);
        setResults([]);
        setLoading(false);
        setErrorMsg('No results found');
        return;
      }
    })
    .catch(error => {
      console.log('error', error);
      if (error.response) {
        console.log('error.response', error.response);
        console.log('error.response.data', error.response.data);
        console.log('error.response.status', error.response.status);
        console.log('error.response.headers', error.response.headers);
        setErrorMsg(error.response);
      }
      if (error.request) {
        console.log('error.request', error.request);
      }
      if (error.message) {
        console.log('error.message', error.message);
      }
      if(error.config) {
        console.log('error.config', error.config);
      }
      if(!errorMsg || errorMsg === ''){
        setErrorMsg(error);
      }
      setError(true);
      setResults([]);
      setLoading(false);
      return;
    });
  };

  useEffect(()=>{
    getOnlineDealers();
  },[])

  const dealers = results.map((result, index) => (
    <StyledDealer key={index}>
    <div className="tile">
      <div className="name">{result.dealer.name}</div>
      <div className="link">
        <a href={result.website.actualUrl} target="_blank" rel="noopener noreferrer">
         {result.website.displayUrl}
        </a>
      </div>
    </div>
  </StyledDealer>
  ));

  return (
    <>
    <OnlineDealerHeader>{site ? site : ''} Online Dealers</OnlineDealerHeader>
    <Row>
    { loading ? <Loader /> : results && results.length ? (
      dealers
    ) : error ? (<h2>ERROR: {errorMsg}</h2>) : null }
        </Row>
    </>
  );
};

export default OnlineDealers;
